define(function (require) {

	//models
	const IPSModel = require('civicsBase/ipsModel');
	const map_extent_model = require('civicsModels/location/map_extent_model');

	//collections
	const IPSCollection = require('civicsBase/ipsModelCollection');
	const nearest_address_collection = require('civicsCollections/location/nearest_address_collection');
	const location_collection = require('civicsCollections/address_collection');

	//utilities
	const view_manager = require('civicsUtils/view_manager');
	const loading_manager = require('civicsUtils/loading_manager');
	const Big = require('civicsUtils/libraries/big');

	return {
		locationObjectShell:{
			addressId: null,//the ID of the IPS Address
			addressData:null,//The full dataset of the IPS Address
			Spatial:{
				xCoordinate:null,
				yCoordinate:null
			},
			selectedText: null,//The autocomplete text selected by the user
			locationNotes: null,//the text to be saved to the location notes field
			reviewMessage: null,//the message, if any, to be displayed in the confirmation/review 
			method: null,//method can be click, locateMe, autocomplete
			isValid: false, /*does this object currently represent a valid site to be saved? This can mean  a found/not 
							found result on autocomplete, clicking, and locating.Basically as long as the user attempted 
							a method this should be set to true. The only way this would not be set is if they are 
							located OUTSIDE of the map extent/ extent from the portletconfig*/
		},
		locationObject:{},
		centerMapOnCoordinatesAndPlacePin: function (coordinates) {
			var mdl = new IPSModel({
				Spatial: {
					xCoordinate: coordinates.x,
					yCoordinate: coordinates.y
				}
			});
			var col = new IPSCollection();
			col.add(mdl);
			this.trigger('collection:updated', {
				collection: col
			});
		},
		checkForSpatial: function (location) {
			var ret = false;
			if (location && location.Spatial && location.Spatial.xCoordinate && location.Spatial.yCoordinate) {
				ret = true;
			}
			return ret;
		},
		clearUserLocation() {
			this.usersCurrentCoordinates = null;	
		},
		getUsersLocation: function (mapExtent, locateMeTimeout) {
			this.resetLocation({ locateMe: true });
			var timeoutMilliseconds = 10000;//don't request location data more than once per ten seconds
			this.resetLocation({ locateMe: true });
			var geoDataPromise = $.Deferred();
			//set a timeout to resolve the geoDataPromise so we don't get stuck when a user's location is failing to return
			//this was a issue reported by daton specifically on phones.
			locateMeTimeout = locateMeTimeout ? locateMeTimeout : 7500;
			setTimeout(function () {
				geoDataPromise.resolve(false);
			}, locateMeTimeout);
			//grab a copy of the coords just in case they're about to be wiped.
			var tempCoords = $.extend({}, this.usersCurrentCoordinates);
			if (tempCoords && tempCoords.x && tempCoords.y) {//if we have coords, use them
				geoDataPromise.resolve(tempCoords);
			} else {
				//we dont have the coordinates saved. So we need to see if we can access them
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition((geoData) => {//success
						if (geoData.coords) {
							var coords = {
								x: geoData.coords.longitude,
								y: geoData.coords.latitude
							};
							if (this.isPointInExtent(coords, mapExtent)) {
								this.usersCurrentCoordinates = coords;
								this.resetLocation({ locateMe: true });
								geoDataPromise.resolve(this.usersCurrentCoordinates);
								setTimeout(this.clearUserLocation.bind(this), timeoutMilliseconds);
							} else {
								geoDataPromise.resolve(false);
							}
						} else {
							geoDataPromise.resolve(false);
						}

					}, () => {
						//fail
						geoDataPromise.resolve(false);
					}, {
						maximumAge: 10,
						timeout: 7500,	//Setting this to 2 seconds works for literally everyone but FF.
						//FF Needs _at least_ 5 seconds to use location services...even when they are HARDCODED into the config.
						//if we see issues in FF with locate me, my gut would be to bump this up further. it doesn't degrade
						//performance in other browsers, but allows FF to walk the coordinates to the user as slow as it likes.
						enableHighAccuracy: true
					});
				} else {
					geoDataPromise.resolve(false);
				}
			}
			return geoDataPromise;
		},
		fetchMapExtent: function (mapConfigName) {
			var prom = $.Deferred();
			var extentModel = new map_extent_model();
			extentModel.mapName = mapConfigName;
			extentModel.fetch().done(() => {
				prom.resolve(extentModel.toJSON());
			})
			return prom;
		},
		findCenterPoint: function (box) {
			if (box && box.length == 4) {
				var x1 = new Big(box[0]);
				var x2 = new Big(box[2]);
				var y1 = new Big(box[1]);
				var y2 = new Big(box[3]);

				var x = (x1.plus(x2)).div(2);
				var y = (y1.plus(y2)).div(2);
				return ({ x: x.toString(), y: y.toString() });
			}
			return null;
		},
		getCountryCode: function (cultureInfo) {
			var ret = 'US'
			var split = cultureInfo.split('-');
			if (split.length == 2) {
				ret = split[1];
			}
			return ret;
		},
		getExtentFromConfig(config){
			var ret = '';
			if(config 
				&& config.newLocation 
				&& config.newLocation.autocompleteMinLat!=''
				&& config.newLocation.autocompleteMinLon!=''
				&& config.newLocation.autocompleteMaxLat!=''
				&& config.newLocation.autocompleteMaxLon!=''){
					ret= config.newLocation.autocompleteMinLat+','+
						config.newLocation.autocompleteMinLon+','+
						config.newLocation.autocompleteMaxLat+','+
						config.newLocation.autocompleteMaxLon
			}
			return ret;
		},
		mapClicked: function (res,extentSize) {
			if (res && res.raw && res.raw.args
				&& res.raw.args.in && res.raw.args.in.findOption) {
				var box = res.raw.args.in.findOption("box");
				var point = this.findCenterPoint(box);
				this.resetLocation({ click: true });
				this.locationObject.Spatial = {
					xCoordinate:point.x,
					yCoordinate:point.y
				}
				//when we click, we center and pin right away. we don't move based on what IPS address we find
				this.centerMapOnCoordinatesAndPlacePin(point);
				this.getIPSAddressForCoordinates(point, extentSize);
			}
			//console.log('map clicked', res)	
		},
		getIPSAddressForCoordinates: function (coordinates,extentSize) {
			//console.log(coordinates);
			loading_manager.loading(true, this);
			var nearestAddressCollection = new nearest_address_collection();
			nearestAddressCollection.coordinates = coordinates;
			nearestAddressCollection.extentSize = extentSize;
			nearestAddressCollection.returnClosestSite = true;
			let retProm = $.Deferred();
			$.when(nearestAddressCollection.fetch()).done((response) => {
				//console.log('extent response',response.data);
				if(nearestAddressCollection.models.length == 1){
					this.IPSAddressFound(nearestAddressCollection.models[0].toJSON())
				} else {
					this.IPSAddressNotFound(coordinates);
				}
				//console.log('Location Object Currently is: ',this.locationObject);
			}).always(() => {
				loading_manager.loading(false, this);
				retProm.resolve();
			});
			return retProm
		},
		IPSAddressFound(address) {
			//we've already centered and pinned for click. now we do so for the other methods.
			if (!this.locationObject.method.click) {
				this.centerMapOnCoordinatesAndPlacePin({
					//if the response has a record, it will always have a spatial with x/y. other wise it wouldn't have been found.
					x: address.Spatial.xCoordinate,
					y: address.Spatial.yCoordinate
				});
			}
			this.locationObject.addressId = address.id;
			this.locationObject.addressData = address;
			this.locationObject.isValid = true;
			if(this.locationObject.method.locateMe || this.locationObject.method.click){
				this.setAddressFieldToAddress(address.displayText);
			}
			if (this.locationObject.method.locateMe) {
				this.locationObject.locationNotes = i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.FOUND_LOCNOTE_LOCATE_ME');
			} else if (this.locationObject.method.click) {
				this.displayMessage(i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.FOUND_MESSAGE_PIN'));
				this.locationObject.locationNotes = i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.FOUND_LOCNOTE_PIN');
				this.locationObject.reviewMessage = i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.FOUND_REVIEW_PIN');
			} else if (this.locationObject.method.autocomplete) {
				this.locationObject.locationNotes = i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.FOUND_LOCNOTE_AUTOCOMPLETE')+' || ' + this.locationObject.selectedText ;
				this.locationObject.reviewMessage = i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.FOUND_REVIEW_AUTOCOMPLETE');
			}

			//console.log('Found ' + address.locationLine1 + '/' + address.locationLine2,address);
		},
		IPSAddressNotFound: function (coordinates) {
			//we've already centered and pinned for click. now we do so for the other methods.
			if (!this.locationObject.method.click) {
				this.centerMapOnCoordinatesAndPlacePin(coordinates);
			}
			this.locationObject.Spatial = {
				xCoordinate:coordinates.x,
				yCoordinate:coordinates.y
			}
			this.locationObject.isValid = true;
			if(this.locationObject.method.locateMe){
				this.displayMessage(i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.NOT_FOUND_MESSAGE_LOCATE_ME'));
				this.locationObject.locationNotes = i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.NOT_FOUND_LOCNOTE_LOCATE_ME');
				this.locationObject.reviewMessage = i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.NOT_FOUND_REVIEW_LOCATE_ME');
			} else if(this.locationObject.method.click){
				this.displayMessage(i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.NOT_FOUND_MESSAGE_PIN'));
				this.locationObject.locationNotes = i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.NOT_FOUND_LOCNOTE_PIN');
				this.locationObject.reviewMessage = i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.NOT_FOUND_REVIEW_PIN');
			} else if (this.locationObject.method.autocomplete) {
				//we don't display a message in this case.
				this.locationObject.locationNotes = i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.NOT_FOUND_LOCNOTE_AUTOCOMPLETE') + ' || ' + this.locationObject.selectedText;
				this.locationObject.reviewMessage = i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.NOT_FOUND_REVIEW_AUTOCOMPLETE');
			}
		},
		isPointInExtent(coordinates, extent) {
			//console.log('Is Coordinate in extent?', coordinates, extent);
			var ret = true;
			if (extent && extent.length > 0) {
				var split = extent.split(',');
				if (split.length == 4) {
					var minX = new Big(split[0]);
					var minY = new Big(split[1]);
					var maxX = new Big(split[2]);
					var maxY = new Big(split[3]);
					var x = new Big(coordinates.x);
					var y = new Big(coordinates.y);
					//the big library uses gte for >=, and lte for <=
					if (!(minX.lte(x) && maxX.gte(x)
						&& minY.lte(y) && maxY.gte(y))) {
						ret = false;
					}
				}
			} else {
				//if we don't have an extent at all, we can't really tell if it's in the extent.
				ret = false;
			}
			return ret;
		},
		//essentially we're trying to spoof the same data we would have produced using the old site view.
		//the old site view is used to display the sites on the review and confirmation pages.
		//see v_lov_sites.js, submitData function in step two of add instruments for more information.
		processLocationData: function (data) {
			//If we have no locationDetails (data.location), and the locationObject is empty, or the location object is not valid, bomb out.
			if ((data.location == null || data.location.length <= 0)
				&& (_.isEmpty(this.locationObject) || this.locationObject.isValid == false)) {
				return { hasPrimarySite: false };//trip up any validation, and/or continue without a location
			} else {
				data.hasPrimarySite = true;
			}
			data.address = { id: 1 };
			data.parcel = { id: 1 };
			data.Spatial = {};
			//we'll leave nonHansenPrimarySite null. It triggers some string concats in v_lov_add_instrument.js for the location
			//details field. We are going to be using the new location notes field for our extra location data instead
			data.nonHansenPrimarySite = null;
			data.associatedProperties = [];//no associated properties for CRM.
			data.selectedProperties = [];//used purely for display purposes in confirmation and review

			//new fields
			data.locationNotes = this.locationObject.locationNotes;

			//when we don't want to display the actual IPS Address, either because we used autocomplete or because we dont have it, we make a fake one
			//this is ONLY used in review and confirmation steps.
			var setFakeAddress = ()=>{
				data.selectedProperties.push({
					siteDescription: this.locationObject.selectedText,
					locationLine1: this.locationObject.selectedText,
					primarySite: true
				});
			}

			if (this.locationObject.addressId!=null) {//if we have an IPS Address ID
				data.address = this.locationObject.addressData;
				if (this.locationObject.method.autocomplete) {
					setFakeAddress();
				} else {
					//Here we want to show the IPS address in review and confirmation
					data.selectedProperties.push(this.locationObject.addressData);
					data.selectedProperties[0].primarySite = true;
				}
				//only track X/Y for pins
				if (this.locationObject.method.click && this.locationObject.Spatial.xCoordinate != null) {
					data.Spatial = this.locationObject.Spatial;
				}
			} else {
				setFakeAddress();
				if (this.checkForSpatial(this.locationObject)) {
					data.Spatial = this.locationObject.Spatial;
				}
			}
			data.selectedProperties[0].reviewMessage = this.locationObject.reviewMessage;
			//console.log('Proceeding with the following data:', data);
			return data;
		},
		//if site isn't null, then we got a primary site on load
		processProvidedSite: function (site, extentSize) {
			if (site == null) {
				return;
			}

			var siteType = site.type ? site.type.trim().toLowerCase() : null;
			//when cloning, coordinates will have a site type of coords. when resuming a saved instrumnent, coords will NOT have a site type, hence the layers of ifs.
			if (!_.isEmpty(siteType) && siteType=='address') {
				this.getIPSDataForLocation({
					AddressKey: site.id
				});
			} else {//Coords
				this.resetLocation({ click: true });
				var point;
				if (site.lon) {//when cloning
					point = { x: site.lon, y: site.lat }
				} else if (site.Spatial) {
					point = { x: site.Spatial.xCoordinate, y: site.Spatial.yCoordinate }
				}
				if (point != null) {
					//this must occur in this order due to the map ready promise not being reliable.
					//when the map ready promise resolves, it doesn't really mean the map is ready.
					//it means it will be ready soon. Searching for the IPS location first buys us some time.
					this.getIPSAddressForCoordinates(point, extentSize).done(() => {
						this.centerMapOnCoordinatesAndPlacePin(point);
					});
				}
			}

		},
		getIPSDataForLocation(location) {
			var locationCollection = new location_collection();
			if (location.AddressKey && location.AddressKey > 1) {
				locationCollection.urlAttributes = {
					passThroughString: 'id=' + location.AddressKey
				};
				locationCollection.siteType = 'address';
			} else {
				//CRM only supports addresses.
				return;
			}
			loading_manager.loading(true, this);
			locationCollection.fetch().done((response) => {
				this.IPSAddressFound(response.data);
				loading_manager.loading(false, this);
			}).fail((response, status, xhrResponse)=> {
				view_manager.errorToWindow(response);
				loading_manager.loading(false, this);
			});
		},
		resetLocation:function(mthd,keepAutocompleteText){
			this.locationObject = $.extend({}, this.locationObjectShell, {method:mthd});
			//we want to just reset the object when we select an autocomplete option.
			//otherwise we would clear the autocomplete field too.
			if (!keepAutocompleteText===true) {
				this.clearAutocomplete();
			}
			this.displayMessage('');
			this.resetErrorMessages();
			this.trigger('collection:cleared');
		},
		setupAutocomplete: function (moniker, parameters, extentSize) {
			view_manager.setupAutoComplete(this, moniker, {
				urlParameters: parameters,
				selectedCallback: (delegateResponse, selectedItem) => {
					if (delegateResponse.location) {
						this.resetLocation({ autocomplete: true },true);
						this.locationObject.selectedText = selectedItem.label;
						//this is kinda unecessary, but it makes the process more consistent
						//additionally it ensures the "oldValue" attr is set.
						this.setAddressFieldToAddress(selectedItem.label);
						this.getIPSAddressForCoordinates(delegateResponse.location, extentSize);
					} else {
						//this means we didn't get an XY back from the autocomplete on select call. This shouldn't happen.
						//console.log('associated xy not found');
						this.resetLocation({autocomplete:true});
					}
				},
				excludeItemCallback: (item) => {
					return item.entries.exclude === true;
				}
			});
		},
	}
});